export default {
  props: {},
  data: function() {
    return {};
  },
  methods: {},
  computed: {
    storeMode: function() {
      return this.$store.state.mode;
    },
    storeDetail: function() {
      return this.$store.state.detail;
    },
    // storeLoading: function() {
    //   return this.$store.state.loading;
    // },
  },
  watch: {
    storeMode(val) {
      //console.log("mode: " + val);
      this.isCurrentMode = val == this.mode;
      },
      // the detail item for the mode.
      // for name search will be a name like "xalatan", for category search will be a category like "glaucoma", for lens details will be a lens id, etc
    // storeDetail(val) {
    //   if (this.isCurrentMode) this.detailChange(val);

    //   //     console.log(this.mode + " match");
    //   // console.log("detail: " + val);
    //   // this.detailChange(val);
    // },
    // storeLoading(val) {
    //   this.loading = val && this.isCurrentMode;
    //   //console.log(this.mode + " match");
    //   // console.log("loading: " + val);
    // },
  },
};
